import { render, staticRenderFns } from "./ZellePagos.vue?vue&type=template&id=719432f2&lang=pug"
import script from "./ZellePagos.vue?vue&type=script&lang=js"
export * from "./ZellePagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports